import { Controller } from "@hotwired/stimulus"
import { showElement, hideElement } from "../helpers/dom_helpers"

export default class extends Controller {
  static targets = ["checkbox", "checkAll", "bulkActions", "selectedCount"]

  connect() {
    this.#uncheckAll()
  }

  toggleAll() {
    const checked = this.checkAllTarget.checked
    this.checkboxTargets.forEach(checkbox => checkbox.checked = checked)
    this.#updateBulkActions()
  }

  toggle() {
    this.#updateCheckAllState()
    this.#updateBulkActions()
  }

  // Private methods

  #updateCheckAllState() {
    const allChecked = this.checkboxTargets.every(cb => cb.checked)
    const someChecked = this.checkboxTargets.some(cb => cb.checked)

    this.checkAllTarget.checked = allChecked
    this.checkAllTarget.indeterminate = someChecked && !allChecked
  }

  #updateBulkActions() {
    const selectedCount = this.#selectedCount

    if (selectedCount > 0) {
      showElement(this.bulkActionsTarget)
      if (this.hasSelectedCountTarget) {
        this.selectedCountTarget.textContent = selectedCount
      }
    } else {
      hideElement(this.bulkActionsTarget)
    }
  }

  #uncheckAll() {
    this.checkAllTarget.checked = false
    this.checkAllTarget.indeterminate = false
    this.checkboxTargets.forEach(cb => cb.checked = false)
    this.#updateBulkActions()
  }

  get #selectedCount() {
    return this.checkboxTargets.filter(cb => cb.checked).length
  }
}
